import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import styled from 'styled-components'
import List from '../components/tokens/List'
import Registry from '../components/tokens/Registry'

export default function Tokens() {
  const [activeTab, setActiveTab] = useState('registry')
  const navigate = useNavigate()
  const { tab } = useParams()

  useEffect(() => {
    if (tab) setActiveTab(tab)
  }, [tab])

  const handleTabClick = (t: string) => {
    setActiveTab(t)
    navigate(`/dashboard/tokens/${t}`)
  }

  return (
    <Wrap>
      <PageTitle>Tokens</PageTitle>
      <TabBar>
        <TabBtn active={activeTab === 'registry'} onClick={() => handleTabClick('registry')}>Registry</TabBtn>
        <TabBtn active={activeTab === 'list'} onClick={() => handleTabClick('list')}>List</TabBtn>
      </TabBar>
      <Content>
        {activeTab === 'registry' && <Registry />}
        {activeTab === 'list' && <List />}
      </Content>
    </Wrap>
  )
}

// ─── Styles ──────────────────────────────────────────────────────────────────

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
`

const PageTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: #ededed;
  margin: 0 0 20px;
`

const TabBar = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  margin-bottom: 24px;
`

const TabBtn = styled.button<{ active: boolean }>`
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  background: none;
  border: none;
  border-bottom: 2px solid ${({ active }) => active ? '#6f5ce6' : 'transparent'};
  margin-bottom: -1px;
  color: ${({ active }) => active ? '#a89aff' : '#555'};
  cursor: pointer;
  transition: color 0.15s, border-color 0.15s;

  &:hover { color: ${({ active }) => active ? '#a89aff' : '#a0a0a0'}; }
`

const Content = styled.div``
